function processArray (target, key, preserveParentNode) {
  return target.reduce((acc, val) => {
    if (val[key]) {
      if (preserveParentNode) {
        return [...acc, val, ...processArray(val[key], key, preserveParentNode)];
      }
      return [...acc, ...processArray(val[key], key, preserveParentNode)];
    }
    return [...acc, val];
  }, []);
}


export default function choicesFlat (target, childKey = 'children', preserveParentNode = false) {
  return processArray(target, childKey, preserveParentNode);
}
